import type { Module } from "@/domains/customers/types/Module"

/**
 * Groups an array of modules by their family property
 * @param modules Array of Module objects to be grouped
 * @returns An object where keys are family names and values are arrays of modules
 */
export function getModulesByFamily(modules: Module[]) {
  return modules.reduce<Record<string, Module[]>>((acc, { family, ...module }) => {
    // Destructure the module object to separate family and other properties
    // Initialize array if it doesn't exist, then push the module
    acc[family] ??= []
    acc[family].push({ family, ...module })

    return acc
  }, {})
}
